import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"

import { useAgentState } from "@/agent-state"
import Icon from "@/components/Icon"
import { routesConfig } from "@/config/routes"
import { useAgentProfile } from "@/hooks/agent-profile"
import MissedInboundCallsCountPill from "@/pages/MissedInboundCalls/count-pill"

type Route = {
  icon: React.ReactNode
  isEnabled: () => boolean
  name: string
  path: string
  pill?: React.ReactNode
  searchParams?: string
}

interface SidebarType {
  isHiddenSidebar: boolean
  navigationRoutes: Route[]
  pathName: string
}

const useSidebarHook = (): SidebarType => {
  const { t } = useTranslation()
  const { isManager } = useAgentProfile()

  const location = useLocation()
  const { state } = useAgentState()

  const navigationRoutes: Route[] = [
    {
      name: t("sidebarMenu.performance"),
      path: "performance",
      icon: <Icon name="dashboard" />,
      isEnabled: () => true,
    },
    {
      name: t("sidebarMenu.campaigns"),
      path: "campaigns",
      icon: <Icon name="campaigns" />,
      isEnabled: () => true, // only create and edit routes are protected
    },
    {
      name: t("sidebarMenu.users"),
      path: "users",
      icon: <Icon name="user-setting" />,
      isEnabled: () => isManager,
    },
    {
      name: t("sidebarMenu.callPanel"),
      path: routesConfig.AUTOMATIC_CALL_PANEL,
      icon: <Icon name="workspace" />,
      isEnabled: () => true,
    },
    {
      name: t("sidebarMenu.noCallList"),
      path: "no-call-list",
      icon: <Icon name="ban" />,
      isEnabled: () => isManager,
    },
    {
      name: t("sidebarMenu.missedCalls"),
      path: "missed-calls",
      icon: <Icon name="phone-missed" />,
      isEnabled: () => true,
      pill: <MissedInboundCallsCountPill />,
    },
  ]

  const isHiddenSidebar =
    state.context.displayStatus === "online" ||
    state.context.displayStatus === "loading"

  return {
    navigationRoutes,
    pathName:
      location.pathname === routesConfig.AUTOMATIC_CALL_PANEL
        ? location.pathname
        : location.pathname.slice(1),
    isHiddenSidebar,
  }
}

export { useSidebarHook }
